/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.applications.rpc.ApplicationsInstallRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getPortalInstallAvailabilityByUserIdRpc = {
  serviceName: 'com.hubspot.applications.rpc.ApplicationsInstallRpc',
  rpcName: 'getPortalInstallAvailabilityByUserId',
  auth: 'app',
  fingerprint: 'QY5ztC6vxbDT6GNX81klqZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getOAuthPortalPickerResponseForUserRpc = {
  serviceName: 'com.hubspot.applications.rpc.ApplicationsInstallRpc',
  rpcName: 'getOAuthPortalPickerResponseForUser',
  auth: 'app',
  fingerprint: 'VTHKsQQ_PMXht_P8hPprSJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getOAuthPortalPickerResponseForPortalRpc = {
  serviceName: 'com.hubspot.applications.rpc.ApplicationsInstallRpc',
  rpcName: 'getOAuthPortalPickerResponseForPortal',
  auth: 'app',
  fingerprint: 'VTHKsQQ_PMU6fHpdXCyrhpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getProbationalMarketplaceDistAppTotalInstallsLimitRpc = {
  serviceName: 'com.hubspot.applications.rpc.ApplicationsInstallRpc',
  rpcName: 'getProbationalMarketplaceDistAppTotalInstallsLimit',
  auth: 'app',
  fingerprint: 'AAAAAAAAAADyncbxattA9pwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPortalsAccessibleToUserRpc = {
  serviceName: 'com.hubspot.applications.rpc.ApplicationsInstallRpc',
  rpcName: 'getPortalsAccessibleToUser',
  auth: 'app',
  fingerprint: 'pq1WqVAr7LBOfymp5eDCZZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAppInstallAllowlistWithDetailsRpc = {
  serviceName: 'com.hubspot.applications.rpc.ApplicationsInstallRpc',
  rpcName: 'getAppInstallAllowlistWithDetails',
  auth: 'app',
  fingerprint: 'EN0rIRZpqHHZjiXuQxx015wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const checkAppAllowlistStatusForPortalsRpc = {
  serviceName: 'com.hubspot.applications.rpc.ApplicationsInstallRpc',
  rpcName: 'checkAppAllowlistStatusForPortals',
  auth: 'app',
  fingerprint: 'djOcjwUOGi7-YOvzsnPBjpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPortalTierUpgradesRequiredToInstallAppRpc = {
  serviceName: 'com.hubspot.applications.rpc.ApplicationsInstallRpc',
  rpcName: 'getPortalTierUpgradesRequiredToInstallApp',
  auth: 'app',
  fingerprint: 'gjAHIb3vo1wWbrcQU6qN6ZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};